import { FC } from 'react';
import { InfiniteScroll } from '../../../../../components/infinite-scroll/infinite-scroll';
import { overlayKey } from '../../../../../helpers/path';
import { useFlashElement } from '../../../../../hooks/use-flash-element/use-flash-element';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useTaskStore } from '../../../../../store/use-task-store';
import { TaskCardItem } from './task-card-item';
import s from './task-cards.module.css';

interface Props {
  onEnd: () => void;
}

export const TaskCards: FC<Props> = (props) => {
  const { onEnd } = props;

  const { t } = useLang();
  const { list, isLoadingFetch } = useTaskStore();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const overlayId = params[overlayKey];
  const elementId = overlayId?.split('-').pop();

  useFlashElement({
    isReady: !isLoadingFetch && !!list?.length,
    selector: `#card-${elementId}`,
  });

  if (!list?.length && !isLoadingFetch) {
    return <div>{t('Здесь пока нет задач')}</div>;
  }

  return (
    <ul className={s.feature}>
      {list?.map((item) => (
        <TaskCardItem key={item.id} item={item} />
      ))}
      <InfiniteScroll onEnterView={onEnd} />
    </ul>
  );
};
